import { useCallback, useMemo } from 'react'

import { useSegment } from '../../../hooks'

enum CardPaymentEvent {
  StripeAccountConnected = 'Stripe Account Connected (Client)',
  StripeAccountConnectionStarted = 'Stripe Account Connection Started (Client)',
  StripeAccountDisconnected = 'Stripe Account Disconnected (Client)',
}

export const useTrackCardPayment = () => {
  const { track } = useSegment()

  const trackStripeAccountConnectionStarted = useCallback(() => {
    track(CardPaymentEvent.StripeAccountConnectionStarted)
  }, [track])

  const trackStripeAccountConnected = useCallback(() => {
    track(CardPaymentEvent.StripeAccountConnected)
  }, [track])

  const trackStripeAccountDisconnected = useCallback(() => {
    track(CardPaymentEvent.StripeAccountDisconnected)
  }, [track])

  return useMemo(
    () => ({
      trackStripeAccountConnected,
      trackStripeAccountConnectionStarted,
      trackStripeAccountDisconnected,
    }),
    [trackStripeAccountConnected, trackStripeAccountConnectionStarted, trackStripeAccountDisconnected],
  )
}
